export default "__VITE_ASSET__Bi$aLuZC__"